var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-checkbox',{on:{"change":function($event){return _vm.onChange()}},model:{value:(_vm.VALUE),callback:function ($$v) {_vm.VALUE=$$v},expression:"VALUE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }